// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__61tDT","row":"Footer_row__oxbkL"};